import React, { useState, useEffect } from "react";
import axios from "axios";
import CustomNavbar from "../CustomPermissions/CustomNavbar";

import { getApiUrl, API_ENDPOINTS, API_BASE_URL } from "../../config/api";

const DesignationPage = () => {
  const [designations, setDesignations] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [newDesignation, setNewDesignation] = useState("");
  const [selectedDept, setSelectedDept] = useState("");
  const [editingDesignation, setEditingDesignation] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    fetchDesignations();
    fetchDepartments();
  }, []);

  const fetchDesignations = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/designations/`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
      });
      setDesignations(response.data);
    } catch (error) {
      // console.error("Error fetching designations:", error);
    }
  };

  const fetchDepartments = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/departments/`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
      });
      setDepartments(response.data);
    } catch (error) {
      console.error("Error fetching departments:", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        name: newDesignation,
        dept: selectedDept
      };

      if (editingDesignation) {
        await axios.put(
          `${API_BASE_URL}/designations/update/${editingDesignation.id}/`,
          payload,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          }
        );
      } else {
        await axios.post(
          `${API_BASE_URL}/designations/create/`,
          payload,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          }
        );
      }
      fetchDesignations();
      closeModal();
    } catch (error) {
      console.error("Error saving designation:", error);
      if (error.response && error.response.data) {
        alert(JSON.stringify(error.response.data));
      }
    }
  };

  const deleteDesignation = async (id) => {
    if (window.confirm("Are you sure you want to delete this designation?")) {
      try {
        await axios.delete(`${API_BASE_URL}/designations/delete/${id}/`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        });
        fetchDesignations();
      } catch (error) {
        // console.error("Error deleting designation:", error);
      }
    }
  };

  const openModal = (designation = null) => {
    if (designation) {
      setEditingDesignation(designation);
      setNewDesignation(designation.name);
      setSelectedDept(designation.dept || ""); // Use dept ID directly if available, or handle based on API response structure
    } else {
      setEditingDesignation(null);
      setNewDesignation("");
      setSelectedDept("");
    }
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setEditingDesignation(null);
    setNewDesignation("");
    setSelectedDept("");
  };

  return (
    <div style={{ display: "flex" }}>
      <CustomNavbar />
      <div className="container-fluid mt-5" style={{ width: "100%", padding: "20px" }}>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <h3 className="mb-4 text-center">Designation Management</h3>

          {/* Add New Designation Button */}
          <button className="btn btn-primary mb-4" onClick={() => openModal()}>
            Add New Designation
          </button>

        </div>

        {/* Designation List */}
        <table className="table table-bordered table-striped">
          <thead className="table-dark">
            <tr>
              <th>ID</th>
              <th>Name</th>
              <th>Department</th>

              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {designations.map((designation) => (
              <tr key={designation.id}>
                <td>{designation.id}</td>
                <td>{designation.name}</td>
                <td>{designation.dept__name || designation.dept}</td>

                <td>
                  <button
                    className="btn btn-warning me-2"
                    onClick={() => openModal(designation)}
                  >
                    Edit
                  </button>
                  <button
                    className="btn btn-danger"
                    onClick={() => deleteDesignation(designation.id)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* Modal for Create/Update */}
        {showModal && (
          <div
            className="modal show d-block fade"
            tabIndex="-1"
            role="dialog"
            style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header bg-primary text-white">
                  <h5 className="modal-title text-white">
                    {editingDesignation
                      ? "Update Designation"
                      : "Create New Designation"}
                  </h5>
                  <button
                    type="button"
                    className="btn-close btn-close-white"
                    onClick={closeModal}
                  ></button>
                </div>
                <div className="modal-body">
                  <form onSubmit={handleSubmit}>
                    <div className="mb-4">
                      <label className="form-label fw-bold">
                        Designation Name
                      </label>
                      <input
                        type="text"
                        name="name"
                        value={newDesignation}
                        onChange={(e) => setNewDesignation(e.target.value)}
                        className="form-control"
                        placeholder="Enter Designation Name"
                        required
                      />
                    </div>

                    <div className="mb-4">
                      <label className="form-label fw-bold">
                        Department
                      </label>
                      <select
                        name="dept"
                        value={selectedDept}
                        onChange={(e) => setSelectedDept(e.target.value)}
                        className="form-control"
                        required
                      >
                        <option value="">Select Department</option>
                        {departments.map((dept) => (
                          <option key={dept.id} value={dept.id}>
                            {dept.name}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="text-end">
                      <button
                        type="button"
                        className="btn btn-secondary me-2"
                        onClick={closeModal}
                      >
                        Cancel
                      </button>
                      <button type="submit" className="btn btn-primary">
                        Save
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default DesignationPage;
